import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Consorcio } from '../../model/consorcio';
import { Socio } from '../../model/socio';
import { SocioService } from '../../services/socio.service';

@Component({
  selector: 'app-socio-mantenimiento',
  templateUrl: './socio-mantenimiento.component.html',
  styleUrls: ['./socio-mantenimiento.component.css']
})
export class SocioMantenimientoComponent implements OnInit {

  @Input() consorcio: Consorcio = new Consorcio();
  @Input() socioSeleccionado: Socio;
  @Output() onReturn = new EventEmitter();

  public socio: Socio = new Socio();
  public estadoBorrar: boolean = false;
  public estadoEditar: boolean = false;

  public consorcios: Consorcio[];


  constructor(
    private _socioService: SocioService
  ) { }


  ngOnInit() {
     if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.socio = this.socioSeleccionado;
    if (this.socio.id != null) {
      this.estadoEditar = true;
    }

  }

  onSubmitSuccess(data: any) {
    this.regresar();
  }

  onSubmit() {
    if (this.socio.id === undefined) {
      this.socio.id = 0;
    }
    this.socio.codigoConsorcio = this.consorcio.codigoConsorcio;
    this._socioService.insert(this.socio).subscribe(
      result =>{ 
        if(result.Resultado === "codigoSocio ya existe en la base de datos"){
            alert("El código del Socio ya existe");
        }else{
          if(result.Resultado === false){
            alert("Ha ocurrido un error...");  
          }else{
            this.onSubmitSuccess(result);
          }
        }
      },
      err => {
        console.clear();
        console.log(err._body);
      });
  }


  regresar() {
    this.onReturn.emit();
  }

  solicitaBorrar() {
    this.estadoBorrar = true;
  }

  solicitudBorrarCancelar() {
    this.estadoBorrar = false;
  }

  borrarRegistro() {
    this._socioService.delete(this.socio).subscribe(
      result => this.regresar(),
      err => {
        console.log(err._body);
      });
  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/socio-mantenimiento/socio-mantenimiento.component.ts